import React, { useEffect, useState } from 'react';
import {
  GoogleMap,
  InfoWindowF,
  MarkerF,
  useJsApiLoader,
} from '@react-google-maps/api';
import './pointsmappage.css';
import resim from '../assets/images/easy_logo.png';
import info from '../assets/images/infoo.png';
import location_logo from '../assets/images/location.png';
import { Points } from '../data/CityList';
import TextField from '@mui/material/TextField';
import SelectSpec from '../components/selectSpec/SelectSpec';
import Services from 'src/services/Services';

const markerIconSize = {
  width: 35,
  height: 35,
};

const containerStyle = {
  width: '100%',
  height: '130vh',
};

const center = {
  lat: 39.9334,
  lng: 32.8597,
};

function PointsMapPage() {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [fetchedLocations, setFetchedLocations] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [csFilter, setCsFilter] = useState([]);
  const [lastFilterList, setLastFilterList] = useState([]);

  // Filter States
  const [cityName, setCityName] = useState('');
  const [pointName, setPointName] = useState('Hepsi');
  const [districtName, setDistrictName] = useState('');
  const [officeName, setOfficeName] = useState('');

  // API Lists
  const [apiCityList, setApiCityList] = useState([]);
  const [apiDistrictList, setApiDistrictList] = useState([]);
  
  useEffect(() => {
    const fetchInitialCities = async () => {
      try {
        const cityRes = await Services.GetCities();

        // API yanıt yapısı: { status: true, result: [ {code: "01", name: "ADANA"}, ... ] }
        if (cityRes.data && cityRes.data.status && cityRes.data.result) {
          const formattedCities = cityRes.data.result
            .map((c) => ({
              id: c.code, // API'den gelen "code" (örn: "06")
              name: c.name, // API'den gelen "name" (örn: "ANKARA")
              townCode: c.code, // İlçe sorgusunda kullanılacak kod
            }))
            .sort((a, b) =>
              a.name.localeCompare(b.name, 'tr', { sensitivity: 'base' })
            );

          setApiCityList(formattedCities);
        }
      } catch (error) {
        console.error('Şehir listesi yüklenemedi', error);
      }
    };

    fetchInitialCities();
    fetchPoints();
  }, []);

  // 2. Şehir değiştiğinde İlçeleri Çek
  useEffect(() => {
    const fetchDistrictsByCity = async () => {
      if (!cityName) {
        setApiDistrictList([]);
        setDistrictName('');
        return;
      }

      // Seçilen şehir kodu
      const selectedCityObj = apiCityList.find((c) => c.name === cityName);

      if (selectedCityObj) {
        try {
          const districtRes = await Services.GetTowns(selectedCityObj.townCode);
          const districtData = districtRes.data.result || districtRes.data;

          if (districtData) {
            const formattedDistricts = districtData
              .map((d) => ({
                id: d.id || d.code,
                name: d.districtName || d.name,
                value: d.districtName || d.name,
              }))
              .sort((a, b) =>
                a.value.localeCompare(b.value, 'tr', { sensitivity: 'base' })
              );

            setApiDistrictList(formattedDistricts);
          }
        } catch (error) {
          console.error('İlçe listesi yüklenemedi', error);
        }
      }
    };

    fetchDistrictsByCity();
  }, [cityName, apiCityList]);

  const fetchPoints = async () => {
    try {
      const response = await Services.GetWebsitePoints();
      if (response.data.status) {
        const result = response.data.result;

        const easyPointsMapped = (result.easypoint || []).map((item) => {
          let workingDaysParsed = null;
          try {
            if (item.working_days) {
              if (typeof item.working_days === 'object') {
                workingDaysParsed = item.working_days;
              } else if (typeof item.working_days === 'string') {
                workingDaysParsed = JSON.parse(item.working_days);
              }
            }
          } catch (e) {
            console.warn('Working days verisi işlenemedi:', item.title, e);
          }

          return {
            status: '1',
            id: Math.random().toString(36).substr(2, 9),
            locator_name: item.title,
            city: item.city,
            district: item.district,
            address: item.address1,
            location: {
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            },
            isBox: item.is_box,
            isEasyPoint: item.is_easypoint,
            isEsnaf: item.is_esnaf,
            isEmanet: false,
            workingDays: workingDaysParsed,
            description: '',
          };
        });

        const emanetPointsMapped = (result.emanet || []).map((item) => ({
          status: '1',
          id: item.locationCode,
          locator_name: item.name,
          city: item.cityName,
          district: item.districtName,
          address: item.address,
          location: {
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
          },
          isBox: false,
          isEasyPoint: false,
          isEsnaf: false,
          isEmanet: true,
          workingDays: null,
          description: '',
        }));

        const allPoints = [...easyPointsMapped, ...emanetPointsMapped];

        setCsFilter(allPoints);
        setFetchedLocations(allPoints);
      }
    } catch (error) {
      console.log('Noktalar çekilirken hata:', error);
    }
  };

  // --- FILTERING LOGIC ---

  const getFilteredPointList = () => {
    let filteredList;
    const isAllSelected = pointName === 'Hepsi' || pointName === '';

    if (isAllSelected || cityName || districtName || officeName || pointName) {
      filteredList = csFilter.filter((item) => {
        const cityNameMatch = cityName
          ? item.city?.toLowerCase().includes(cityName?.toLowerCase())
          : true;

        let pointTypeMatch = true;
        if (isAllSelected) {
          pointTypeMatch =
            item.isBox || item.isEasyPoint || item.isEsnaf || item.isEmanet;
        } else {
          if (pointName === 'Box') pointTypeMatch = item.isBox;
          else if (pointName === 'EasyPoint') pointTypeMatch = item.isEasyPoint;
          else if (pointName === 'Esnaf') pointTypeMatch = item.isEsnaf;
          else if (pointName === 'Emanet') pointTypeMatch = item.isEmanet;
        }

        const districtNameMatch = districtName
          ? item.district
              ?.toLocaleLowerCase('tr')
              .includes(districtName.toLocaleLowerCase('tr'))
          : true;

        const officeNameMatch = officeName
          ? item.locator_name?.toLowerCase().includes(officeName?.toLowerCase())
          : true;

        return (
          cityNameMatch &&
          pointTypeMatch &&
          districtNameMatch &&
          officeNameMatch
        );
      });
    } else {
      filteredList = csFilter;
    }

    setLastFilterList(filteredList);
  };

  useEffect(() => {
    if (csFilter.length > 0) {
      getFilteredPointList();
    }
  }, [csFilter, cityName, pointName, districtName, officeName]);

  // --- GOOGLE MAPS SETTINGS ---

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyC7Yo4dlBRWcC_XUbTH2IEgYdPLsvHJZzs',
  });

  const onMarkerClick = (location, index) => {
    setSelectedLocation(location);
    setSelectedCardIndex(index);
  };

  const onCloseClick = () => {
    setSelectedLocation(null);
    setSelectedCardIndex(null);
  };

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    map.setZoom(6);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const openMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleOfficeName = (e) => {
    const { value } = e.target;
    setOfficeName(value);
  };

  const handleResetSearchBar = () => {
    setOfficeName('');
  };

  const clearFilters = () => {
    setCityName('');
    setPointName('');
    setDistrictName('');
    setOfficeName('');
  };

  return isLoaded ? (
    <div className="container d-flex">
      {/* ... Left Menu Structure ... */}
      <div className={`mobil_menu left md-none `}>
        <img
          className="img_logo"
          width={200}
          src={resim}
          alt="Easypoint Logo"
          onClick={openMenu}
        />
        {isOpen ? (
          <div className="icon-close" onClick={openMenu}></div>
        ) : (
          <div className="icon-menu" onClick={openMenu}></div>
        )}
      </div>
      <div className={`left_column flex-1 ${isOpen ? 'spar' : 'mobile-none'} `}>
        <div className="p-3 mt-4">
          <div className="p-4 text-align-center">
            <hr className="custom-hr"></hr>
          </div>
          <div className="box-no-show">Easy Point Noktaları</div>

          <label className="info_logo mt-4 p-1">
            Easy Point Noktası Seçin
            <img
              style={{ display: 'inline-block', marginLeft: 5 }}
              src={info}
              alt="info logo"
            ></img>
          </label>

          <SelectSpec
            onChange={setPointName}
            selectedValue={pointName}
            name={'nokta'}
            customArray={Points}
            placeTitle="Easy Point Noktası Seçiniz"
            index={'1'}
          />

          <label className="info_logo mt-4 p-1">İl Seçin </label>
          <SelectSpec
            onChange={setCityName}
            selectedValue={cityName}
            name={'il'}
            customArray={apiCityList}
            placeTitle="İl Seçiniz"
            index={'2'}
          />

          <label className="info_logo mt-4 p-1">İlçe Seçin </label>
          <SelectSpec
            onChange={setDistrictName}
            selectedValue={districtName}
            name={'ilce'}
            customArray={apiDistrictList}
            placeTitle="İlçe Seçiniz"
            index={'3'}
            disablek={cityName ? false : true}
          />
          <div className="animated zoomIn">
            <label className="info_logo mt-4 p-1">
              Teslimat Noktası Adı Arayın{' '}
            </label>
            <TextField
              placeholder="Teslimat Noktası Adı Arayın"
              value={officeName}
              onChange={handleOfficeName}
              id="outlined-basic"
              variant="outlined"
              className="searchbar"
            />

            {officeName.length > 0 ? (
              <div
                style={{ position: 'absolute', right: '10px', top: '60%' }}
                className="icon-close"
                onClick={handleResetSearchBar}
              ></div>
            ) : (
              ''
            )}
          </div>
          <div className="animated zoomIn buttons m-4 text-align-center">
            <button className="custom-btn clear-btn" onClick={clearFilters}>
              Temizle
            </button>
            <button
              className="custom-btn filter-btn"
              onClick={getFilteredPointList}
            >
              Filtrele
            </button>
          </div>
        </div>
      </div>
      <div className={`right_column ${isOpen ? 'flex-0' : 'flex-3'} `}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={6}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          {lastFilterList?.map((location, index) => {
            if (location.status === '1') {
              return (
                <MarkerF
                  icon={{
                    url: location_logo,
                    scaledSize: markerIconSize,
                  }}
                  key={index}
                  onClick={() => onMarkerClick(location, index)}
                  position={location.location}
                />
              );
            } else {
              return null;
            }
          })}

          {selectedLocation && (
            <InfoWindowF
              position={selectedLocation.location}
              onCloseClick={onCloseClick}
            >
              <div className="heroko">
                <h2>{selectedLocation?.locator_name}</h2>
                <h3>
                  <span style={{ fontWeight: 'bold', color: '#DC423C' }}>
                    Şehir:
                  </span>
                  {selectedLocation?.city}
                </h3>
                <h4>
                  <span style={{ fontWeight: 'bold', color: '#DC423C' }}>
                    Adres:
                  </span>{' '}
                  {selectedLocation?.address}
                </h4>

                {selectedLocation?.workingDays && (
                  <h4>
                    <span style={{ fontWeight: 'bold', color: '#DC423C' }}>
                      Çalışma Saatleri:
                    </span>{' '}
                    {selectedLocation.workingDays?.friday?.openingTime ? (
                      <>
                        {selectedLocation.workingDays.friday.openingTime.hour}:
                        {selectedLocation.workingDays.friday.openingTime.minute}{' '}
                        - {selectedLocation.workingDays.friday.closingTime.hour}
                        :
                        {selectedLocation.workingDays.friday.closingTime.minute}
                      </>
                    ) : (
                      <span>Belirtilmedi</span>
                    )}
                  </h4>
                )}

                {selectedLocation?.location?.lat &&
                  selectedLocation?.location?.lng && (
                    <div style={{ marginTop: '10px', marginBottom: '5px' }}>
                      <a
                        href={`http://maps.google.com/maps?q=${selectedLocation.location.lat},${selectedLocation.location.lng}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: 'rgb(220, 66, 60)',
                          textDecoration: 'none',
                          fontWeight: 'bold',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        📍 Yol Tarifi Al
                      </a>
                    </div>
                  )}

                <p>{selectedLocation?.description}</p>
              </div>
            </InfoWindowF>
          )}
        </GoogleMap>
      </div>
    </div>
  ) : null;
}

export default PointsMapPage;
